import * as Yup from 'yup';

const REQUIRED_FIELD = 'This field is required.';
export const validationSchema = Yup.object({
  fbBusiness: Yup.object()
    .shape({
      value: Yup.string().required(REQUIRED_FIELD),
      label: Yup.string().required(REQUIRED_FIELD),
    })
    .nullable()
    .required(REQUIRED_FIELD),
  fbPage: Yup.object()
    .shape({
      value: Yup.string().required(REQUIRED_FIELD),
      label: Yup.string().required(REQUIRED_FIELD),
    })
    .nullable()
    .required(REQUIRED_FIELD),
  fbPixel: Yup.object()
    .shape({
      value: Yup.string().required(REQUIRED_FIELD),
      label: Yup.string().required(REQUIRED_FIELD),
    })
    .nullable()
    .required(REQUIRED_FIELD),
  igAccount: Yup.object()
    .shape({
      value: Yup.string(),
      label: Yup.string(),
    })
    .nullable(),
  productCatalog: Yup.object()
    .shape({
      value: Yup.string(),
      label: Yup.string(),
    })
    .nullable(),
  fbAdAccount: Yup.object({
    value: Yup.string(),
    label: Yup.string(),
  })
    .nullable()
    .required(REQUIRED_FIELD),
});
